// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__Btn from "../../../html/Btn.js";
import * as Buhta_cabinet__CalendarDatePickerInput from "../../../molecules/CalendarDatePickerInput.js";
import * as Buhta_cabinet__Checkbox from "../../../html/Checkbox.js";
import * as Buhta_cabinet__Date from "../../../../util/Date.js";
import * as Buhta_cabinet__Field from "../../../html/Field.js";
import * as Buhta_cabinet__Modal from "../../../molecules/Modal.js";
import * as Buhta_cabinet__RadioButton from "../../../html/RadioButton.js";
import * as Buhta_cabinet__Toggle from "../../../atoms/Toggle.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as DateTime from "../../../../../../../packages/util/lib/DateTime.js";
import * as Decimal from "../../../../../../../packages/util/lib/Decimal.js";
import * as MelNumeral from "../../../../../../../packages/util/lib/MelNumeral.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib from "melange/stdlib.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function sumAmount(items) {
  return Belt__Belt_List.reduce(items, Decimal.make(0), (function (sum, item) {
    const amount = item.amount;
    if (amount !== undefined) {
      return Decimal.plus(sum, Decimal.fromString(amount));
    } else {
      return sum;
    }
  }));
}

function TaxPaymentsOrdersForm(Props) {
  let isDirectorOpt = Props.isDirector;
  let info = Props.info;
  let earnings = Props.earnings;
  let isModalShownOpt = Props.isModalShown;
  let setIsModalShownOpt = Props.setIsModalShown;
  const isDirector = isDirectorOpt !== undefined ? isDirectorOpt : false;
  const isModalShown = isModalShownOpt !== undefined ? isModalShownOpt : false;
  const setIsModalShown = setIsModalShownOpt !== undefined ? setIsModalShownOpt : (function (param) {
      
    });
  const match = React.useState(function () {
    return "";
  });
  const setBirthday = match[1];
  const match$1 = React.useState(function () {
    return "";
  });
  const setTin = match$1[1];
  const match$2 = React.useState(function () {
    return "";
  });
  const setLastname = match$2[1];
  const match$3 = React.useState(function () {
    return "";
  });
  const setName = match$3[1];
  const match$4 = React.useState(function () {
    return "";
  });
  const setPatronymicName = match$4[1];
  const match$5 = React.useState(function () {
    return /* PERSON_STATUS_UNSPECIFIED */ 0;
  });
  const setEmploymentType = match$5[1];
  const employmentType = match$5[0];
  const match$6 = React.useState(function () {
    return "option1";
  });
  const setPaymentTypeOption = match$6[1];
  const paymentTypeOption = match$6[0];
  const match$7 = React.useState(function () {
    return "";
  });
  const setSalary = match$7[1];
  const salary = match$7[0];
  const match$8 = React.useState(function () {
    return false;
  });
  const setIsStandardTaxes = match$8[1];
  const isStandardTaxes = match$8[0];
  const match$9 = React.useState(function () {
    return false;
  });
  const setIsBenefit = match$9[1];
  const isBenefit = match$9[0];
  const match$10 = React.useState(function () {
    return false;
  });
  const setIsRetired = match$10[1];
  const isRetired = match$10[0];
  const match$11 = React.useState(function () {
    return false;
  });
  const setIsRetiredByYearsServed = match$11[1];
  const isRetiredByYearsServed = match$11[0];
  const match$12 = React.useState(function () {
    return false;
  });
  const setIsDisabled = match$12[1];
  const isDisabled = match$12[0];
  const match$13 = React.useState(function () {
    return false;
  });
  const setIsDisabledIndefinitely = match$13[1];
  const isDisabledIndefinitely = match$13[0];
  const match$14 = React.useState(function () {
    return false;
  });
  const setIsParent = match$14[1];
  const isParent = match$14[0];
  const match$15 = React.useState(function () {
    return false;
  });
  const setIsMother = match$15[1];
  const isMother = match$15[0];
  const match$16 = React.useState(function () {
    return false;
  });
  const setIsStudent = match$16[1];
  const isStudent = match$16[0];
  const match$17 = React.useState(function () {
    return /* PERSON_CATEGORY_UNSPECIFIED */ 0;
  });
  const disabledCategory = match$17[0];
  const match$18 = React.useState(function () {
    return /* PERSON_CATEGORY_UNSPECIFIED */ 0;
  });
  const disabledPermanentCategory = match$18[0];
  const taxCategoryName = function (category) {
    switch (category) {
      case /* TAX_CATEGORY_UNSPECIFIED */ 0 :
        return "";
      case /* TAX_CATEGORY_ESP */ 1 :
        return "Единый совокупный платеж";
      case /* TAX_CATEGORY_IPN */ 2 :
        return "Индивидуальный подоходный налог";
      case /* TAX_CATEGORY_OPV */ 3 :
        return "Обязательные пенсионные взносы";
      case /* TAX_CATEGORY_OPVR */ 4 :
        return "Обязательные пенсионные взносы работодателя";
      case /* TAX_CATEGORY_OOSMS */ 5 :
        return "Отчисления на соц. мед. страхование";
      case /* TAX_CATEGORY_SO */ 6 :
        return "Социальные отчисления";
      case /* TAX_CATEGORY_VOSMS */ 7 :
        return "Взносы на соц. мед. страхование";
      case /* TAX_CATEGORY_SN */ 8 :
        return "Социальный налог";
    }
  };
  let disabledCategory$1;
  switch (disabledCategory) {
    case /* PERSON_CATEGORY_DISABLED_GROUP_1 */ 3 :
    case /* PERSON_CATEGORY_DISABLED_GROUP_2 */ 5 :
    case /* PERSON_CATEGORY_DISABLED_GROUP_3 */ 7 :
      disabledCategory$1 = disabledCategory;
      break;
    default:
      disabledCategory$1 = /* PERSON_CATEGORY_UNSPECIFIED */ 0;
  }
  let disabled_category_permanent;
  switch (disabledPermanentCategory) {
    case /* PERSON_CATEGORY_DISABLED_GROUP_1_PERMANENT */ 4 :
    case /* PERSON_CATEGORY_DISABLED_GROUP_2_PERMANENT */ 6 :
      disabled_category_permanent = disabledPermanentCategory;
      break;
    default:
      disabled_category_permanent = /* PERSON_CATEGORY_UNSPECIFIED */ 0;
  }
  const categoryBenefits = Stdlib.$at(/* [] */ 0, Stdlib.$at(isRetired ? ({
      hd: /* PERSON_CATEGORY_PENSIONER_AGE */ 1,
      tl: /* [] */ 0
    }) : /* [] */ 0, Stdlib.$at(isRetiredByYearsServed ? ({
      hd: /* PERSON_CATEGORY_PENSIONER_DUTY */ 2,
      tl: /* [] */ 0
    }) : /* [] */ 0, Stdlib.$at(isDisabled ? ({
      hd: disabledCategory$1,
      tl: /* [] */ 0
    }) : /* [] */ 0, Stdlib.$at(isDisabledIndefinitely ? ({
      hd: disabled_category_permanent,
      tl: /* [] */ 0
    }) : /* [] */ 0, Stdlib.$at(isParent ? ({
      hd: /* PERSON_CATEGORY_GUARDIAN_DISABLED */ 9,
      tl: /* [] */ 0
    }) : /* [] */ 0, Stdlib.$at(isMother ? ({
      hd: /* PERSON_CATEGORY_MOTHER_MANY */ 15,
      tl: /* [] */ 0
    }) : /* [] */ 0, isStudent ? ({
      hd: /* PERSON_CATEGORY_STUDENT */ 16,
      tl: /* [] */ 0
    }) : /* [] */ 0)))))));
  const taxDeductionBenefits = Stdlib.$at(/* [] */ 0, isStandardTaxes ? ({
      hd: /* TAX_DEDUCTION_TYPE_14_MRP */ 3,
      tl: /* [] */ 0
    }) : /* [] */ 0);
  console.log("categoryBenefits", categoryBenefits);
  console.log("taxDeductionBenefits", taxDeductionBenefits);
  React.useEffect((function () {
    const date = info.birthday_date;
    const birthday_date = date !== undefined ? Buhta_cabinet__Date.toString(date) : "";
    const name = info.patronymic_name;
    const patronymic_name = name !== undefined ? name : "";
    Curry._1(setTin, (function (param) {
      return info.tin;
    }));
    Curry._1(setName, (function (param) {
      return info.given_name;
    }));
    Curry._1(setLastname, (function (param) {
      return info.family_name;
    }));
    Curry._1(setPatronymicName, (function (param) {
      return patronymic_name;
    }));
    Curry._1(setBirthday, (function (param) {
      return birthday_date;
    }));
    const lastEarning = Belt__Belt_List.getExn(earnings, Belt__Belt_List.length(earnings) - 1 | 0);
    Curry._1(setSalary, (function (param) {
      return lastEarning.gross_income;
    }));
    Curry._1(setEmploymentType, (function (param) {
      return lastEarning.status;
    }));
    Curry._1(setIsStandardTaxes, (function (param) {
      return Belt__Belt_List.length(lastEarning.tax_deduction_types) > 0;
    }));
    Curry._1(setIsBenefit, (function (param) {
      return Belt__Belt_List.length(lastEarning.categories) > 0;
    }));
    const __x = lastEarning.categories;
    Belt__Belt_List.forEach(__x, (function (cb) {
      switch (cb) {
        case /* PERSON_CATEGORY_PENSIONER_AGE */ 1 :
          return Curry._1(setIsRetired, (function (param) {
            return true;
          }));
        case /* PERSON_CATEGORY_PENSIONER_DUTY */ 2 :
          return Curry._1(setIsRetiredByYearsServed, (function (param) {
            return true;
          }));
        case /* PERSON_CATEGORY_DISABLED_GROUP_2 */ 5 :
          return Curry._1(setIsDisabled, (function (param) {
            return true;
          }));
        case /* PERSON_CATEGORY_DISABLED_GROUP_2_PERMANENT */ 6 :
          return Curry._1(setIsDisabledIndefinitely, (function (param) {
            return true;
          }));
        case /* PERSON_CATEGORY_GUARDIAN_DISABLED */ 9 :
          return Curry._1(setIsParent, (function (param) {
            return true;
          }));
        case /* PERSON_CATEGORY_MOTHER_MANY */ 15 :
          return Curry._1(setIsMother, (function (param) {
            return true;
          }));
        case /* PERSON_CATEGORY_STUDENT */ 16 :
          return Curry._1(setIsStudent, (function (param) {
            return true;
          }));
        default:
          return;
      }
    }));
  }), [info]);
  const benefits = JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                children: "Применить льготы"
              }),
              JsxRuntime.jsx("img", {
                className: "w-5 h-5",
                alt: "info",
                src: StaticAsset.src("/static/icons/info.svg")
              })
            ],
            className: "flex gap-2 items-center"
          }),
          JsxRuntime.jsx(Buhta_cabinet__Toggle.make, {
            checked: isBenefit,
            onChange: (function (value) {
              Curry._1(setIsBenefit, (function (param) {
                return value;
              }));
            })
          })
        ],
        className: "flex justify-between items-center mt-6"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
            isChecked: isRetired,
            onChange: (function (param) {
              Curry._1(setIsRetired, (function (param) {
                return !isRetired;
              }));
            }),
            text: "Пенсионер по возрасту",
            subText: "мужчины — 63, женщины — 61"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
                isChecked: isRetiredByYearsServed,
                onChange: (function (param) {
                  Curry._1(setIsRetiredByYearsServed, (function (param) {
                    return !isRetiredByYearsServed;
                  }));
                }),
                text: "Пенсионер по выслуге лет"
              }),
              JsxRuntime.jsx("img", {
                className: "w-5 h-5",
                alt: "info",
                src: StaticAsset.src("/static/icons/info.svg")
              })
            ],
            className: "flex gap-2 items-center"
          }),
          JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
            isChecked: isDisabled,
            onChange: (function (param) {
              Curry._1(setIsDisabled, (function (param) {
                return !isDisabled;
              }));
            }),
            text: "Инвалид I, II, III группы"
          }),
          JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
            isChecked: isDisabledIndefinitely,
            onChange: (function (param) {
              Curry._1(setIsDisabledIndefinitely, (function (param) {
                return !isDisabledIndefinitely;
              }));
            }),
            text: "Инвалид I, II группы бессрочно"
          }),
          JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
            isChecked: isParent,
            onChange: (function (param) {
              Curry._1(setIsParent, (function (param) {
                return !isParent;
              }));
            }),
            text: "Родитель/опекун инвалида"
          }),
          JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
            isChecked: isMother,
            onChange: (function (param) {
              Curry._1(setIsMother, (function (param) {
                return !isMother;
              }));
            }),
            text: "Многодетная мать",
            subText: "4 и более детей"
          }),
          JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
            isChecked: isStudent,
            onChange: (function (param) {
              Curry._1(setIsStudent, (function (param) {
                return !isStudent;
              }));
            }),
            text: "Студент"
          })
        ],
        className: Cn.$plus("space-y-4 mt-4", Cn.on("hidden", !isBenefit))
      }),
      JsxRuntime.jsx("hr", {
        className: "my-6"
      })
    ]
  });
  return JsxRuntime.jsxs(Buhta_cabinet__Modal.make, {
    isShown: isModalShown,
    onClose: (function (param) {
      Curry._1(setIsModalShown, (function (param) {
        return false;
      }));
    }),
    title: isDirector ? "Данные о руководителе предприятия" : "Данные о сотруднике",
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Buhta_cabinet__Field.make, {
              label: "ИИН",
              type_: "text",
              name: "tin",
              size: "m",
              required: true,
              onChange: (function (value) {
                Curry._1(setTin, (function (param) {
                  return value;
                }));
              }),
              value: match$1[0]
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                  label: "Фамилия",
                  type_: "text",
                  name: "lastname",
                  size: "m",
                  required: true,
                  onChange: (function (value) {
                    Curry._1(setLastname, (function (param) {
                      return value;
                    }));
                  }),
                  value: match$2[0]
                }),
                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                  label: "Имя",
                  type_: "text",
                  name: "name",
                  size: "m",
                  required: true,
                  onChange: (function (value) {
                    Curry._1(setName, (function (param) {
                      return value;
                    }));
                  }),
                  value: match$3[0]
                }),
                JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                  label: "Отчество",
                  type_: "text",
                  name: "patronymicName",
                  size: "m",
                  onChange: (function (value) {
                    Curry._1(setPatronymicName, (function (param) {
                      return value;
                    }));
                  }),
                  value: match$4[0]
                })
              ],
              className: "flex gap-4 mt-6"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Buhta_cabinet__CalendarDatePickerInput.make, {
                value: match[0],
                onPicked: (function (date) {
                  Curry._1(setBirthday, (function (param) {
                    return DateTime.toDateFormat(date);
                  }));
                }),
                align: "BottomRight",
                className: "w-full",
                label: "Дата рождения",
                isBirthDay: true
              }),
              className: "flex gap-4 mt-6"
            }),
            isDirector ? JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                        label: "Доход руководителя",
                        type_: "text",
                        name: "salary",
                        size: "m",
                        required: true,
                        onChange: (function (value) {
                          Curry._1(setSalary, (function (param) {
                            return value;
                          }));
                        }),
                        value: salary.length !== 0 ? MelNumeral.formatInt({
                            NAME: "Str",
                            VAL: salary
                          }) : ""
                      }),
                      JsxRuntime.jsx("img", {
                        className: "absolute right-4 top-4 w-5 h-5",
                        alt: "tenge",
                        src: StaticAsset.src("/static/icons/tenge.svg")
                      })
                    ],
                    className: "relative mt-4"
                  }),
                  JsxRuntime.jsxs(Buhta_components__Text.Caption.make, {
                    className: "text-asphalt mt-1",
                    children: [
                      "Минимальная сумма — ",
                      JsxRuntime.jsx("span", {
                        children: "85 000 ₸",
                        className: "text-links cursor-pointer",
                        onClick: (function (param) {
                          Curry._1(setSalary, (function (param) {
                            return "85000";
                          }));
                        })
                      })
                    ]
                  })
                ]
              }) : JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                    className: "text-default-gray mt-6 font-semibold",
                    children: "ТИП СОТРУДНИКА"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                        className: "mt-4",
                        checked: employmentType === /* PERSON_STATUS_SALARY */ 1,
                        onChange: (function (param) {
                          Curry._1(setEmploymentType, (function (param) {
                            return /* PERSON_STATUS_SALARY */ 1;
                          }));
                        }),
                        children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                          className: "ml-1",
                          children: "Трудовой договор"
                        })
                      }),
                      JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                        className: "mt-4",
                        checked: employmentType === /* PERSON_STATUS_CONTRACTED */ 2,
                        onChange: (function (param) {
                          Curry._1(setEmploymentType, (function (param) {
                            return /* PERSON_STATUS_CONTRACTED */ 2;
                          }));
                        }),
                        children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                          className: "ml-1",
                          children: "ГПХ"
                        })
                      })
                    ],
                    className: "flex gap-6"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                        className: "text-default-gray mt-6 font-semibold",
                        children: "МЕТОД РАСЧЕТА"
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                            className: "mt-4",
                            checked: paymentTypeOption === "option1",
                            onChange: (function (param) {
                              Curry._1(setPaymentTypeOption, (function (param) {
                                return "option1";
                              }));
                            }),
                            children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                              className: "ml-1",
                              children: [
                                "От обратного",
                                JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                  className: "text-gray-medium",
                                  children: "Зарплата на руки"
                                })
                              ]
                            })
                          }),
                          JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
                            className: "mt-4",
                            checked: paymentTypeOption === "option2",
                            onChange: (function (param) {
                              Curry._1(setPaymentTypeOption, (function (param) {
                                return "option2";
                              }));
                            }),
                            children: JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                              className: "ml-1",
                              children: [
                                "Прямой расчет",
                                JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                  className: "text-gray-medium",
                                  children: "Зарплата с налогами"
                                })
                              ]
                            })
                          })
                        ],
                        className: "flex gap-6"
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                            label: "Зарплата за июнь",
                            type_: "text",
                            name: "salary",
                            size: "m",
                            required: true,
                            onChange: (function (value) {
                              Curry._1(setSalary, (function (param) {
                                return value;
                              }));
                            }),
                            value: salary.length !== 0 ? MelNumeral.formatInt({
                                NAME: "Str",
                                VAL: salary
                              }) : ""
                          }),
                          JsxRuntime.jsx("img", {
                            className: "absolute right-4 top-4 w-5 h-5",
                            alt: "tenge",
                            src: StaticAsset.src("/static/icons/tenge.svg")
                          })
                        ],
                        className: "relative mt-4"
                      }),
                      JsxRuntime.jsxs(Buhta_components__Text.Caption.make, {
                        className: "text-asphalt mt-1",
                        children: [
                          "Минимальная сумма — ",
                          JsxRuntime.jsx("span", {
                            children: "85 000 ₸",
                            className: "text-links cursor-pointer",
                            onClick: (function (param) {
                              Curry._1(setSalary, (function (param) {
                                return "85000";
                              }));
                            })
                          })
                        ]
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                children: "Применить стандартный налоговый вычет"
                              }),
                              JsxRuntime.jsx("img", {
                                className: "w-5 h-5",
                                alt: "info",
                                src: StaticAsset.src("/static/icons/info.svg")
                              })
                            ],
                            className: "flex gap-2 items-center"
                          }),
                          JsxRuntime.jsx(Buhta_cabinet__Toggle.make, {
                            checked: isStandardTaxes,
                            onChange: (function (value) {
                              Curry._1(setIsStandardTaxes, (function (param) {
                                return value;
                              }));
                            })
                          })
                        ],
                        className: Cn.$plus("flex justify-between items-center mt-6", Cn.on("hidden", employmentType === /* PERSON_STATUS_CONTRACTED */ 2))
                      })
                    ]
                  })
                ]
              }),
            benefits,
            Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(earnings, (function (index, earning) {
              const payrollDeductions = sumAmount(earning.payroll_deductions);
              const payrollTaxes = sumAmount(earning.payroll_taxes);
              const totalAmount = Decimal.plus(payrollDeductions, payrollTaxes);
              const Key = String(index);
              const __x = earning.payroll_deductions;
              const __x$1 = earning.payroll_taxes;
              return JsxRuntime.jsxs("div", {
                children: [
                  isDirector ? null : JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "text-asphalt-dark",
                              children: "Зарплата на руки"
                            }),
                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              children: MelNumeral.formatInt({
                                NAME: "Str",
                                VAL: earning.net_income
                              }) + " ₸"
                            })
                          ],
                          className: "flex justify-between"
                        }),
                        JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "text-asphalt-dark",
                              children: "Зарплата с налогами"
                            }),
                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              children: MelNumeral.formatInt({
                                NAME: "Str",
                                VAL: earning.gross_income
                              }) + " ₸"
                            })
                          ],
                          className: "flex justify-between"
                        })
                      ],
                      className: "flex flex-col gap-1 mb-4"
                    }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x, (function (index, tax) {
                        const amount = tax.amount;
                        const taxAmount = amount !== undefined ? amount : "";
                        const Key = String(index);
                        return JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "text-asphalt-dark",
                              children: taxCategoryName(tax.tax_category)
                            }),
                            taxAmount === "" ? JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                    className: "text-success",
                                    children: "Освобожден"
                                  }),
                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                    children: "0 ₸"
                                  })
                                ],
                                className: "flex gap-1"
                              }) : JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                children: MelNumeral.formatInt({
                                  NAME: "Str",
                                  VAL: taxAmount
                                }) + " ₸"
                              })
                          ],
                          className: "flex justify-between"
                        }, Key);
                      }))),
                      Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x$1, (function (index, tax) {
                        const amount = tax.amount;
                        const taxAmount = amount !== undefined ? amount : "";
                        const Key = String(index);
                        return JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "text-asphalt-dark",
                              children: taxCategoryName(tax.tax_category)
                            }),
                            taxAmount === "" ? JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                    className: "text-success",
                                    children: "Освобожден"
                                  }),
                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                    children: "0 ₸"
                                  })
                                ],
                                className: "flex gap-1"
                              }) : JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                children: MelNumeral.formatInt({
                                  NAME: "Str",
                                  VAL: taxAmount
                                }) + " ₸"
                              })
                          ],
                          className: "flex justify-between"
                        }, Key);
                      })))
                    ],
                    className: "flex flex-col gap-1"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                        className: "text-asphalt-dark",
                        children: "Итого"
                      }),
                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                        className: "!font-mediumbold",
                        children: MelNumeral.formatInt({
                          NAME: "Str",
                          VAL: Decimal.toString(totalAmount)
                        }) + " ₸"
                      })
                    ],
                    className: "flex justify-between mt-4"
                  })
                ]
              }, Key);
            })))
          ],
          className: "p-10"
        }),
        className: "bg-white w-[562px] rounded-md"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
          title: "Сохранить",
          className: "px-6 py-3",
          type_: "submit"
        }),
        className: "w-[562px] flex justify-end px-10 pb-10"
      })
    ],
    wrapperClassName: "w-[562px] max-h-full overflow-y-auto"
  });
}

const make = TaxPaymentsOrdersForm;

export {
  sumAmount,
  make,
}
/* Buhta_cabinet__Btn Not a pure module */
